module.exports = __webpack_public_path__ + "img/user.8f93db25.jpg";